import { render, staticRenderFns } from "./GenFormEdit.vue?vue&type=template&id=5d66e61a&scoped=true&"
import script from "./GenFormEdit.vue?vue&type=script&lang=js&"
export * from "./GenFormEdit.vue?vue&type=script&lang=js&"
import style0 from "./GenFormEdit.vue?vue&type=style&index=0&id=5d66e61a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d66e61a",
  null
  
)

export default component.exports